import {environment} from "@environments/environment";
import {LieuParam} from "@domain/common/lieu/lieu-param";

/**
 * Paramétrage pour la partie od du lieu
 */
export class LieuParamOd extends LieuParam {
    /** Indicateur du paramétrage des saisie pour l'od */
    isSaisieAdresseOD: boolean;

    /** {@inheritDoc} */
    isRevenirOngletSaisieAdresseAfterSelect = true;

    /** {@inheritDoc} */
    isSaisieAutorisee = () => {
        return this.isSaisieAdresseOD;
    }

    /** {@inheritDoc} */
    placeHolder = (libelleAdresse: String,isDisabled: boolean) => {
        return libelleAdresse
            ? ''
            : isDisabled
                ? 'lieu.aucuneSelection'
                : 'lieu.selectionnerLieu';
    };

    /** {@inheritDoc} */
    isShowAdresseBaseAndEtablissement = true;

    /** {@inheritDoc} */
    titleAdresseTab = 'lieu.tabs.mesAdresses';

    /** {@inheritDoc} */
    isGeolocaliserWithoutRue = true;

    /** {@inheritDoc} */
    isValiderWarningWithoutGeolocalisation = true;

    /**
     * Constructeur
     */
    constructor(idObject: number,isSaisieAdresseOD: boolean,idUser: number) {
        super();

        this.urlAdresse = `${environment.baseUrl}/controller/OD/${idObject}/getListeLieux`;

        this.isSaisieAdresseOD = isSaisieAdresseOD;

        this.idUser = idUser;
    }
}